/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';

export default function Icon({ title = null }) {
  return (
    <svg role="img" aria-labelledby="documentMoneyIcon" width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      {title && <title id="documentMoneyIcon">{title}</title>}
      <path d="M7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V9.414C18.9999 9.1488 18.8946 8.89449 18.707 8.707L13.293 3.293C13.1055 3.10545 12.8512 3.00006 12.586 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21Z" stroke="#585F69" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 8.5C10.343 8.5 9 9.395 9 10.5C9 11.605 10.343 12.5 12 12.5C13.657 12.5 15 13.395 15 14.5C15 15.605 13.657 16.5 12 16.5M12 8.5V16.5M12 8.5C13.11 8.5 14.08 8.902 14.599 9.5M12 8.5V7.5M12 16.5V17.5M12 16.5C10.89 16.5 9.92 16.098 9.401 15.5" stroke="#585F69" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

Icon.propTypes = {
  title: PropTypes.string,
};
